import { ContentAdviceBox } from '../content/advice-box';
import { ContentAppFeaturePreview } from '../content/app-feature-preview';
import { ContentAudio } from '../content/audio';
import { ContentAuthor } from '../content/author';
import { ContentAvatar } from '../content/avatar';
import { BenefitsList } from '../content/benefits-list';
import { BenefitsListImage } from '../content/benefits-list-image';
import { ContentButton } from '../content/button';
import { ContentCategoryLinkList } from '../content/category-link-list';
import { ContentCiveySurvey } from '../content/civey-survey';
import { ContentComparisonTable } from '../content/comparison-table';
import { ContentCooperationInfobox } from '../content/cooperation-infobox';
import { ContentFAQ } from '../content/faq';
import { ContentFinder } from '../content/finder';
import { ContentHighCharts } from '../content/high-charts';
import { ContentImagesDecorative } from '../content/images-decorative';
import { ContentImagesInformative } from '../content/images-informative';
import { ContentInPageNavigation } from '../content/in-page-navigation';
import { ContentInfo } from '../content/info';
import { ContentIntro } from '../content/intro';
import { ContentJobSearch } from '../content/job-search';
import { ContentLinda } from '../content/linda';
import { ContentMigrationPlaceholder } from '../content/migration-placeholder';
import { ContentNumberCounter } from '../content/number-counter';
import { ContentNumberDivider } from '../content/number-divider';
import { ContentOpenerContentPage } from '../content/opener-content-page';
import { ContentPortraitBox } from '../content/portrait-box';
import { ContentProductLinkList } from '../content/product-link-list';
import { ContentQuiz } from '../content/quiz';
import { ContentQuote } from '../content/quote';
import { ContentArticleText } from '../content/section';
import { ContentServiceLinkList } from '../content/service-link-list';
import { ContentServiceTeaserGallery } from '../content/service-teaser-gallery';
import { ContentSimpleTable } from '../content/simple-table';
import { ContentSiteSearch } from '../content/site-search';
import { ContentSplitPaper } from '../content/split-paper';
import { ContentStepper } from '../content/stepper';
import { ContentTopInfoBox } from '../content/top-info-box';
import { ContentTrustElement } from '../content/trust-element';
import { ContentVideo } from '../content/video';
import { ContentWallTeaserGallery } from '../content/wall-teaser-gallery';
import { AdditionalCostCalculator } from '../forms/additional-cost-calculator';
import { BruttoNettoCalculator } from '../forms/brutto-netto-calculator';
import { FormsBudgetCalculator } from '../forms/budget-calculator';
import { FormsCapitalCalculator } from '../forms/capital-calculator';
import { FormsContactForm } from '../forms/contact-form';
import { FormsFuelCostCalculator } from '../forms/fuel-cost-calculator';
import { FormsHomeConstructionLoanCalculator } from '../forms/home-construction-loan-calculator';
import { HouseholdCalculator } from '../forms/household-calculator';
import { IbanCalculator } from '../forms/iban-calculator';
import { FormsModernisationCalculator } from '../forms/modernisation-calculator';
import { FormsPensionCalculator } from '../forms/pension-calculator';
import { FormsPensionGapCalculator } from '../forms/pension-gap-calculator';
import { FormsPriceEstimator } from '../forms/price-estimator';
import { FormsPrivateLoanCalculator } from '../forms/private-loan-calculator';
import { FormsRentalCalculator } from '../forms/rental-calculator';
import { FormsRepaymentCalculator } from '../forms/repayment-calculator';
import { FormsSaveplanCalculator } from '../forms/saveplan-calculator';
import { FormsSkpCalculator } from '../forms/skp-calculator';
import { FormsSparkasseAssignmentForm } from '../forms/sparkasse-assignment-form';

/**
 * Model definition for InstituteSpecificContentItem
 */
export interface InternInstituteSpecificContentItem {
  __component: 'intern.institute-specific-content-item';
  id: string;
  text?: string;
  bankCodes?: string;
  content: (
    | ContentAudio
    | ContentAppFeaturePreview
    | ContentAuthor
    | ContentAvatar
    | BenefitsList
    | BenefitsListImage
    | ContentButton
    | ContentCategoryLinkList
    | ContentCiveySurvey
    | ContentFAQ
    | ContentHighCharts
    | ContentImagesInformative
    | ContentImagesDecorative
    | ContentInPageNavigation
    | ContentInfo
    | ContentIntro
    | ContentJobSearch
    | ContentLinda
    | ContentMigrationPlaceholder
    | ContentNumberCounter
    | ContentNumberDivider
    | ContentOpenerContentPage
    | ContentPortraitBox
    | ContentAdviceBox
    | ContentFinder
    | ContentQuiz
    | ContentTrustElement
    | ContentProductLinkList
    | ContentQuote
    | ContentArticleText
    | ContentServiceLinkList
    | ContentServiceTeaserGallery
    | ContentSimpleTable
    | ContentStepper
    | ContentSplitPaper
    | ContentTopInfoBox
    | ContentVideo
    | ContentWallTeaserGallery
    | ContentComparisonTable
    | ContentSiteSearch
    | ContentCooperationInfobox
    | FormsContactForm
    | AdditionalCostCalculator
    | BruttoNettoCalculator
    | FormsSaveplanCalculator
    | FormsHomeConstructionLoanCalculator
    | FormsCapitalCalculator
    | HouseholdCalculator
    | FormsFuelCostCalculator
    | IbanCalculator
    | FormsRentalCalculator
    | FormsBudgetCalculator
    | FormsModernisationCalculator
    | FormsPensionGapCalculator
    | FormsPensionCalculator
    | FormsPriceEstimator
    | FormsSkpCalculator
    | FormsSparkasseAssignmentForm
    | FormsRepaymentCalculator
    | FormsPrivateLoanCalculator
  )[];
}

export function isInternInstituteSpecificContentItem(obj: {
  __component?: string;
}): obj is InternInstituteSpecificContentItem {
  return obj.__component === 'intern.institute-specific-content-item';
}
